import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import { UserContract } from '@nrdy-marketing-engine/cart/@types/contract';

// Auth will be provided by default from the include:credentials option in apifetch
export const signContracts = async (uuid: string, contractIds: string[]): Promise<{}> => {
  if (!uuid || contractIds?.length !== 2) return;

  const queryParams = `?contractIds[]=${contractIds.join('&contractIds[]=')}`;
  const endpoint = `/vtwa/v5/clients/${uuid}/contracts/sign${queryParams}`;

  return apiFetch<UserContract[]>(endpoint, {
    method: 'PATCH',
  })
    .then((signResponse) => signResponse as any)
    .catch((err) => {
      console.error('Error signing contracts - ', err);
    });
};

export default signContracts;
